'use strict'

# UserAgent
_ua = do ->
  IE = document.uniqueID
  ltIE6 = typeof window.addEventListener is undefined and typeof document.documentElement.style.maxHeight is undefined
  ltIE7 = typeof window.addEventListener is undefined and typeof document.querySelectorAll is undefined
  ltIE8 = typeof window.addEventListener is undefined and typeof document.getElementsByClassName is undefined
  ltIE9 = IE and typeof window.Worker is undefined
  IE6 = IE and ltIE6
  IE7 = IE and ltIE7 and not ltIE6
  IE8 = IE and ltIE8 and not ltIE7 and not ltIE6
  IE9 = IE and ltIE9 and not ltIE8 and not ltIE7 and not ltIE6
  IE10 = IE and not ltIE9 and not ltIE8 and not ltIE7 and not ltIE6
  Webkit = not document.uniqueID and not window.opera and not window.sidebar and not window.orientation and window.localStorage
  Safari = Webkit and navigator.vendor.search(/apple/i) isnt -1
  Chrome = Webkit and navigator.vendor.search(/google/i) isnt -1

  return {
    IE:IE,
    ltIE6:ltIE6,
    ltIE7:ltIE7,
    ltIE8:ltIE8,
    ltIE9:ltIE9,
    IE6:IE6,
    IE7:IE7,
    IE8:IE8,
    IE9:IE9,
    IE10:IE10,
    Firefox:window.sidebar,
    Opera:window.opera,
    Webkit:Webkit,
    Safari:Safari,
    Chrome:Chrome,
    Mobile:window.orientation
  }

# URL
url = do ->
  href = location.href.split('/')

  localRegex = /^\d+\.\d+\.\d+\.\d+/
  workRegex = /^.*\/pc\/[^\/]+\/.*$/
  workRegex2 = /^.*next\..*\/[^\/]+\/.*$/

  for val , i in href
    if val is '' or i is href.length - 1 and val.indexOf('.')
      href.splice(i,1)

  if localRegex.test(location.hostname) is true or location.hostname.indexOf('localhost') isnt -1 or workRegex2.test(location.href) is true
    length = 2

  else if workRegex.test(location.href) is true
    length = 3

    for val , i in href
      if val is 'pc' and href[i-1] is 'work'
        length = 4

  else
    length = 1

  path = ''

  for j in [0..(length)]
    path += href[j]

    if j is 0
      path += '//'

    else
      path += '/'

  return path

$(()->
  $id = $('body').attr('id')
  $class = $('body').attr('class')

smoothScroll = ($target)->
  if window.matchMedia('(max-width:750px)').matches
    $(
      if(navigator.userAgent.indexOf('Opera') isnt -1)
      then (
        if document.compatMode is 'BackCompat'
        then 'body'
        else 'html'
      )
      else 'html,body'
    ).animate({
      scrollTop: $($target.attr('href')).offset().top - $('.navi-open').height() * 2.4
    },{
      easing:'easeInOutCirc',
      duration:1000
    })
    return false
  else
    $(
      if(navigator.userAgent.indexOf('Opera') isnt -1)
      then (
        if document.compatMode is 'BackCompat'
        then 'body'
        else 'html'
      )
      else 'html,body'
    ).animate({
      scrollTop: $($target.attr('href')).offset().top - $('.sub-header').height() + 1
    },{
      easing:'easeInOutCirc',
      duration:1000
    })
    return false

$('a[href^="#"]'+'a[href!="#"]').not('.js-tab-item').on('click.smoothScroll'
  (e)->
    e.preventDefault()
    smoothScroll($(this))

    return
)

$gnavi =$('.navi')
$gnaviItem =$('.navi__list__item')
$navContents = $('.navi-point')
navContentsPos = {}

$navContents.each(
  (index, val)->
    if $(this).attr('id')
      position = {}
      position[$(this).attr('id')] = $(this).offset().top
      navContentsPos[Object.keys(navContentsPos).length] = position
)

$(window).scroll(
  ()->
    $.each(navContentsPos,
      (key, val)->
        target = Object.keys(val)
        $target = $('#'+target)

        if $(window).scrollTop() >= $target.position().top - $gnavi.height() and
        $(window).scrollTop() < $target.position().top + $target.outerHeight(true)
          $gnavi.find('.'+target).addClass('is-active')
          $gnaviItem.not('.'+target).removeClass('is-active')

        if $(window).scrollTop() < $($navContents.get(0)).position().top - $gnavi.height()
          $gnaviItem.removeClass('is-active')

        # if $(window).scrollTop() + $(window).height() >= $target.position().top and
        # $(window).scrollTop() + $(window).height() < $target.position().top + $target.outerHeight(true)
        #   if $target.hasClass('js-has-cv')
        #     if not $('.l-fix-cv').hasClass('is-hide')
        #       $('.l-fix-cv').addClass('is-hide')
        #   else
        #     if $('.l-fix-cv').hasClass('is-hide')
        #       $('.l-fix-cv').removeClass('is-hide')
    )
)

$('.accordion__title, .navi__list__item' ).on('click',
  ()->
    $parent = $root = $(this).closest('.accordion')
    $parent.removeClass('is-close')
    $parent.toggleClass('is-open')
    parentContentsHeight = rootContentsHeight = $parent.find('> .accordion__contents > .accordion__contents__inner').outerHeight()

    if $parent.hasClass('is-open')
      $parent.find('> .accordion__contents').css({
        'height': parentContentsHeight
        'maxHeight': parentContentsHeight
      })
    else
      $parent.find('> .accordion__contents').removeAttr('style')

    if $parent.hasClass('is-open-all')
      $parent.toggleClass('is-open-all')
      $parent.addClass('is-close-all')
    else if $parent.hasClass('is-close-all')
      $parent.toggleClass('is-close-all')
      $parent.addClass('is-open-all')

    if $parent.hasClass('js-subaccordion')
      $root = $parent.parents('.js-accordion')
      rootContentsHeight = $root.find('> .accordion__contents > .accordion__contents__inner').outerHeight()

      if $root.hasClass('is-open') and $parent.hasClass('is-open')
        $root.addClass('is-open-all')
      else
        $root.removeClass('is-open-all')

      if $root.hasClass('is-open')
        if $root.hasClass('is-open-all')
          allContentsHeight = if parentContentsHeight isnt rootContentsHeight then rootContentsHeight + parentContentsHeight else parentContentsHeight
        else
          allContentsHeight = if parentContentsHeight isnt rootContentsHeight then rootContentsHeight - parentContentsHeight else parentContentsHeight

        $root.find('> .accordion__contents').removeAttr('style')
        $root.find('> .accordion__contents').css({
          'height': allContentsHeight
          'maxHeight': allContentsHeight
        })

    $parent.on('oTransitionEnd mozTransitionEnd webkitTransitionEnd transitionend',
      ()->
        if not $parent.hasClass('is-open')
          $parent.addClass('is-close')
    )
)

$('.p-covid-19__modal').not('.p-covid-19__modal__inner').on('click',
  (e)->
    if $('.p-covid-19__modal').hasClass('is-active')
      if e.target isnt e.currentTarget
        return
      else
        $('body').removeClass('is-fixed')
        $('.p-covid-19__modal').removeClass('is-active')
        window.scrollTo( 0 , scrollPosition )
)

scrollPosition = ''

$('.p-covid-19__headline').on('click',
  ()->
    scrollPosition = $(window).scrollTop()
    $('body').addClass('is-fixed')
    $('.p-covid-19__modal').addClass('is-active')
)

$('.modal-close').on('click',
  ()->
    $('body').removeClass('is-fixed')
    $('.p-covid-19__modal').removeClass('is-active')
    window.scrollTo( 0 , scrollPosition )
)

$('.js-tab-item').each(
  ()->
    $(this).find('a[href^="#"]').off('click.smoothScroll')
)

$url = new URL(window.location.href)
$param = $url.searchParams

$(window).on('load', ()->
  if $param.get('clinic')
    if $('.js-tab-item.' + $param.get('clinic')).length
      # console.log($('.js-tab-item.' + $param.get('clinic')).length)
      $('.js-tab-item.' + $param.get('clinic') + ' a[href^="#"]').trigger('click')
)

$('.js-tab-item a[href^="#"]').on('click',
  (e)->
    $parent = $(this).closest('.js-tab-box')
    e.preventDefault()
    $parent.find('.js-tab-item').removeClass('is-active')
    $(this).parent().addClass('is-active')
    $parent.find('.js-tab-box-contents').removeClass('is-active')
    $($(this).attr('href')).addClass('is-active')
)

$('.p-clinic__info__contents__details__clinics__item').on('click',
  (e)->
    $('.p-clinic__info__tab__item').removeClass('is-active')
    linkTab = $(this).attr('data-link')
    $('#' + linkTab).addClass('is-active')
)

)
